<template>
    <v-container fluid class="px-0">
        <v-row>
            <v-col cols="12" sm="6" md="12">
                <here-to-help-kicker class="mb-6"></here-to-help-kicker>
                <get-prepared-kicker class="mb-6"></get-prepared-kicker>
                <free-bus-travel-kicker></free-bus-travel-kicker>
            </v-col>
            <v-col cols="12" sm="6" md="12">
                <campus-guides-kicker class="mb-6"></campus-guides-kicker>
                <societies-kicker class="mb-6"></societies-kicker>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import hereToHelpKicker from '@/views/components/kickers/HereToHelpKicker'
    import getPreparedKicker from '@/views/components/kickers/GetPreparedKicker'
    import freeBusTravelKicker from '@/views/components/kickers/FreeBusTravelKicker'
    import campusGuidesKicker from '@/views/components/kickers/CampusGuidesKicker'
    import societiesKicker from '@/views/components/kickers/SocietiesKicker'

    export default {
        components: {
            'here-to-help-kicker': hereToHelpKicker,
            'get-prepared-kicker': getPreparedKicker,
            'free-bus-travel-kicker': freeBusTravelKicker,
            'campus-guides-kicker': campusGuidesKicker,
            'societies-kicker': societiesKicker,
        }
    }
</script>
